import React from 'react';
import { bool, array, string, number, node, func, oneOfType } from 'prop-types';
import classnames from 'classnames';
import SimpleSlider from './SimpleSlider';
import SlickSlider from './SlickSlider';
import { SLIDER_BREAKPOINTS, SLIDES_TO_SHOW, INITIAL_SLIDE, AUTOPLAY_SPEED, EASING, SLIDING_SPEED } from './SlickSlider/constants';

/**
 * @deprecated since version 4.62.2, please use @fiverr-private/carousel instead
 */
const Slider = ({
    freeScroll,
    items,
    Component,
    mixpanelEvent,
    slidesToShow,
    sliderBreakpoints,
    isInfinite,
    afterChange,
    onArrowClick,
    initialSlide,
    useDots,
    useArrows,
    autoplay,
    autoplaySpeed,
    smallArrows,
    slidesToScroll = slidesToShow,
    speed,
    easing,
    useTransform,
    className
}) => {
    if (!items || !items.length) {
        return null;
    }

    return (
        <div className={classnames('orca-slider', className)}>
            { freeScroll ?
                <SimpleSlider items={items}
                    Component={Component}
                    mixpanelEvent={mixpanelEvent}/>
                : (
                    <SlickSlider items={items}
                        Component={Component}
                        mixpanelEvent={mixpanelEvent}
                        slidesToShow={slidesToShow}
                        sliderBreakpoints={sliderBreakpoints}
                        initialSlide={initialSlide}
                        isInfinite={isInfinite}
                        afterChange={afterChange}
                        useDots={useDots}
                        autoplay={autoplay}
                        autoplaySpeed={autoplaySpeed}
                        useArrows={useArrows}
                        smallArrows={smallArrows}
                        onArrowClick={onArrowClick}
                        slidesToScroll={slidesToScroll}
                        speed={speed}
                        easing={easing}
                        useTransform={useTransform}/>
                )
            }
        </div>
    );
};

Slider.displayName = 'Slider';

Slider.defaultProps = {
    freeScroll: false,
    items: [],
    slidesToShow: SLIDES_TO_SHOW,
    sliderBreakpoints: SLIDER_BREAKPOINTS,
    isInfinite: true,
    afterChange: Function.prototype,
    onArrowClick: Function.prototype,
    initialSlide: INITIAL_SLIDE,
    useDots: false,
    useArrows: true,
    autoplay: false,
    autoplaySpeed: AUTOPLAY_SPEED,
    smallArrows: false,
    speed: SLIDING_SPEED,
    easing: EASING
};

Slider.propTypes = {
    freeScroll: bool,
    items: array.isRequired,
    Component: oneOfType([
        node,
        func
    ]).isRequired,
    slidesToShow: number,
    initialSlide: number,
    sliderBreakpoints: array,
    isInfinite: bool,
    afterChange: func,
    useDots: bool,
    useArrows: bool,
    mixpanelEvent: string,
    autoplay: bool,
    autoplaySpeed: number,
    onArrowClick: func,
    smallArrows: bool,
    slidesToScroll: number,
    speed: number,
    easing: string,
    useTransform: bool,
    className: string
};

Object.assign(Slider, {
    SLIDER_BREAKPOINTS
});

export default Slider;
